import React from 'react';
import FieldItem from './FieldItem';

const TemplateFieldEditor = ({
  editingFields,
  expandedFields,
  selectedFieldId,
  showVariables,
  addField,
  updateField,
  removeField,
  addContentLine,
  updateContentLine,
  removeContentLine,
  toggleLineBold,
  toggleVariablesPanel,
  insertVariable,
  insertVariableNewLine,
  toggleFieldExpansion,
  expandAllFields,
  collapseAllFields,
  moveFieldUp,
  moveFieldDown,
  moveFieldToPosition,
  moveColumnUp,
  moveColumnDown,
}) => (
  <div style={{ display: 'flex', flexDirection: 'column', height: '100%' }}>
    <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: '10px', flexShrink: 0 }}>
      <h4 style={{ margin: 0, color: 'var(--text)', fontSize: '14px' }}>
        Pola ({editingFields.length})
      </h4>
      <button
        onClick={addField}
        style={{
          border: '1px solid var(--success)', color: 'var(--success)',
          backgroundColor: 'transparent',
          padding: '4px 10px', cursor: 'pointer', fontSize: '12px',
        }}
      >
        + Dodaj pole
      </button>
    </div>

    <div style={{ flex: 1, overflow: 'auto' }}>
      {editingFields.length === 0 ? (
        <div style={{ padding: '20px', textAlign: 'center', color: 'var(--text-muted)', fontSize: '13px' }}>
          Brak pol. Kliknij "Dodaj pole" aby rozpoczac.
        </div>
      ) : (
        <>
          <div style={{
            marginBottom: '8px', display: 'flex', gap: '6px', flexWrap: 'wrap',
            padding: '6px', backgroundColor: 'var(--bg)', borderRadius: '4px',
          }}>
            <button
              onClick={expandAllFields}
              style={{
                border: '1px solid var(--info)', color: 'var(--info)', backgroundColor: 'transparent',
                padding: '4px 10px', cursor: 'pointer', fontSize: '11px',
              }}
            >
              Rozwin wszystkie
            </button>
            <button
              onClick={collapseAllFields}
              style={{
                border: '1px solid var(--text-muted)', color: 'var(--text-muted)', backgroundColor: 'transparent',
                padding: '4px 10px', cursor: 'pointer', fontSize: '11px',
              }}
            >
              Zwin wszystkie
            </button>
          </div>

          {editingFields.map((field, index) => (
            <FieldItem
              key={field.id}
              field={field}
              index={index}
              totalFields={editingFields.length}
              isExpanded={expandedFields[field.id]}
              isSelected={selectedFieldId === field.id}
              toggleFieldExpansion={toggleFieldExpansion}
              moveFieldUp={moveFieldUp}
              moveFieldDown={moveFieldDown}
              removeField={removeField}
              updateField={updateField}
              updateContentLine={updateContentLine}
              toggleLineBold={toggleLineBold}
              removeContentLine={removeContentLine}
              addContentLine={addContentLine}
              toggleVariablesPanel={toggleVariablesPanel}
              showVariables={showVariables}
              insertVariable={insertVariable}
              insertVariableNewLine={insertVariableNewLine}
              moveFieldToPosition={moveFieldToPosition}
              editingFields={editingFields}
              moveColumnUp={moveColumnUp}
              moveColumnDown={moveColumnDown}
            />
          ))}
        </>
      )}
    </div>
  </div>
);

export default TemplateFieldEditor;
